import PostListItem, {PostListItemData, PostListItemInterface} from '../post/PostListItem'
import PostTag, {PostTagData, PostTagInterface} from "../post/PostTag";
import {IconData, IconInterface} from "../Icon";
import {MediaData, MediaInterface} from "../Media";
import {BannerListItemData} from "../banner/BannerListItem";

export enum ListEntityItemType {
  banner = 'banner', company = 'company', icon = 'icon',
  post = 'post', post_tag = 'post_tag', promotion = 'promotion',
  shop_item = 'shop_item', user = 'user'
}

export interface ListEntityItemData {
  id: number
  entity: /* BannerData */ BannerListItemData | /*| CompanyListItemData | */
    IconData | MediaData | PostListItemData | PostTagData /* | ShopListItemData | UserListItemData */
  properties: Object | null
  sort_num: number
  type: ListEntityItemType
}

export interface ListEntityItemInterface {
  id(): number

  type(): ListEntityItemType

  entity(): /*BannerInterface | CompanyListItemInterface | */
    IconInterface | MediaInterface | PostListItemInterface | PostTagInterface /* | ShopListItemInterface | UserListItemInterface */
  properties(): Object | null

  sortNum(): number
}

export default class ListEntityItem implements ListEntityItemInterface {
  private data: ListEntityItemData
  private readonly _entity: /*BannerInterface | CompanyListItemInterface | */
    IconInterface | MediaInterface | PostListItemInterface | PostTagInterface /* | ShopListItemInterface | UserListItemInterface */

  public constructor(data: ListEntityItemData) {
    this.data = data
    switch (true) {
      case data.type === ListEntityItemType.post_tag :
        this._entity = new PostTag(data.entity as PostTagData)
        break;
      case data.type === ListEntityItemType.post :
        this._entity = new PostListItem(data.entity as PostListItemData)
        break;
      default:
        throw new Error('undefined type of entity')
    }
  }

  public id(): number {
    return this.data.id
  }

  public type(): ListEntityItemType {
    return this.data.type
  }

  public entity(): /*BannerInterface | CompanyListItemInterface | */
    IconInterface | MediaInterface | PostListItemInterface | PostTagInterface /* | ShopListItemInterface | UserListItemInterface */ {
    return this._entity
  }

  public properties(): Object | null {
    return this.data.properties
  }

  public sortNum(): number {
    return this.data.sort_num
  }
}
